import React from 'react';

class Test extends React.Component {
}

export default Test;